import _ from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { ButtonGroup, Button, Col, Nav, Row, Tab } from 'react-bootstrap';
import Auth from '../../services/AuthService';
import ApiService from '../../services/ApiService';
import browserHistory from '../../history';
import { ScaleLoader } from 'react-spinners';
import { modal } from '../modal/ModalEmitter';
import VoidRo from '../form/actions/VoidRo';
import PrintHardCard from '../form/actions/PrintHardCard';
import QuoteHistory from '../crm/QuoteHistory';
import QuoteDocuments from '../crm/QuoteDocuments';
import ViewNotes from '../crm/ViewNotes';
import PaymentCreditForm from '../payment/PaymentCreditForm';
import PaymentSaleFormResume from '../payment/PaymentSaleFormResume';
import { cancelInvoice, validateInvoice } from '../../util/payment';
import PdfObject from '../PdfObject';
import toastr from '../toastr';
import PaymentSessionRefund from '../payment/PaymentSessionRefund';
import PaymentSession from '../payment/PaymentSession';

class ListRowToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attachments: props.attachments,
      notes: props.noteCount,
    };
  }

  handleRemoveItem = () => {
    const { itemName, itemId } = this.props;
    this.props.handleRemoveItem(itemName, itemId);
  };

  nav(route) {
    browserHistory.push(route);
  }

  switchUser() {
    modal.confirm({
      message: 'Switching users will log you out of your current user!',
      callback: () => {
        Auth.login(null, null, this.props.itemId).then(() => {
          location.href = '/';
        });
      },
    });
  }

  showAttachments({ readOnly = false, rowData }) {
    const { itemName, itemId } = this.props;

    const handleChange = attachments => {
      const count = Array.isArray(attachments) ? attachments.length : 0;
      this.setState({ attachments: count });
    };

    modal.open('attachments', {
      itemName,
      itemId,
      itemData: rowData,
      readOnly,
      onChange: handleChange,
    });
  }

  showNotes(rowData = {}) {
    const { itemName } = this.props;
    const { dealId, id } = rowData;

    const callback = notes => {
      const count = Array.isArray(notes) ? notes.length : 0;
      this.setState({ notes: count });
    };

    modal.open('viewNotes', {
      hideFooter: true,
      hidePrint: true,
      size: 'md',
      style: 'center',
      title: `View Notes ${id}`,
      message: <ViewNotes dealId={dealId} listItem={id} listName={itemName} callback={callback} />,
    });
  }

  renderReadButton() {
    const { canRead, itemName, rowData } = this.props;

    if (!canRead) {
      return null;
    }

    let url = `/${this.props.namespace}/${this.props.itemName}/${encodeURIComponent(this.props.itemId)}`;

    if (itemName === 'EQS1') {
      url = `/${this.props.namespace}/EQS2/${encodeURIComponent(rowData.dealId)}/edit/home`;
    }

    return (
      <Button
        variant="secondary"
        size="xs"
        title="View"
        onClick={event => {
          if (event.ctrlKey) {
            window.open(url);
          } else {
            this.nav(url);
          }
        }}
        className="list-view-button"
      >
        <i className="fas fa-search fa-fw" />
      </Button>
    );
  }

  renderAddButton() {
    const { canCopy } = this.props;

    if (!canCopy) {
      return null;
    }

    return (
      <Button
        variant="success"
        size="xs"
        title="Copy"
        onClick={event => {
          const url = `/${this.props.namespace}/${this.props.itemName}/${encodeURIComponent(this.props.itemId)}/copy`;
          if (event.ctrlKey) {
            window.open(url);
          } else {
            this.nav(url);
          }
        }}
        className="list-copy-button"
      >
        <i className="fas fa-copy fa-fw" />
      </Button>
    );
  }

  renderEditButton() {
    const { canEdit, itemName, rowData } = this.props;

    if (!canEdit || ['UPY5', 'UPY6'].includes(itemName)) {
      return null;
    }

    let url;
    switch (itemName) {
      case 'EQS1':
        url = `/${this.props.namespace}/EQS2/${encodeURIComponent(rowData.dealId)}/edit?oq=${this.props.itemId}`;
        break;
      case 'UST3R':
        url = `/${this.props.namespace}/${this.props.itemName}/${encodeURIComponent(rowData.userId)}/edit`;
        break;
      default:
        url = `/${this.props.namespace}/${this.props.itemName}/${encodeURIComponent(this.props.itemId)}/edit`;
    }

    return (
      <Button
        variant="primary"
        size="xs"
        title="Edit"
        onClick={event => {
          if (event.ctrlKey) {
            window.open(url);
          } else {
            this.nav(url);
          }
        }}
        className="list-edit-button"
      >
        <i className="fas fa-edit fa-fw" />
      </Button>
    );
  }

  renderDeleteButton() {
    const { canDelete } = this.props;

    if (!canDelete) {
      return null;
    }

    return (
      <Button onClick={this.handleRemoveItem} variant="danger" size="xs" title="Delete" className="list-delete-button">
        <i className="fas fa-times fa-fw" />
      </Button>
    );
  }

  renderPermissionsButton() {
    if (this.props.itemName !== 'UST3') {
      return null;
    }

    return (
      <Button
        onClick={event => {
          const url = `/${this.props.namespace}/UST3R/${this.props.itemId}/edit`;
          if (event.ctrlKey) {
            window.open(url);
          } else {
            this.nav(url);
          }
        }}
        variant="info"
        size="xs"
        title="Edit Permissions"
      >
        <i className="fad fa-lock-alt fa-fw" />
      </Button>
    );
  }

  renderSwitchUserButton() {
    if (this.props.itemName !== 'UST3') {
      return null;
    }

    if (_.get(Auth.getUser(), 'username') !== 'dsisupport') {
      return null;
    }

    return (
      <Button
        onClick={() => {
          this.switchUser();
        }}
        variant="warning"
        size="xs"
        title="Switch User"
      >
        <i className="fad fa-user-friends fa-fw" />
      </Button>
    );
  }

  renderUploadButton() {
    const { canUpload, canViewAttachments, rowData } = this.props;

    if (!canUpload && !canViewAttachments) {
      return null;
    }

    const readOnly = canViewAttachments && !canUpload;

    const { attachments } = this.state;

    return (
      <Button
        onClick={() => {
          this.showAttachments({ readOnly, rowData });
        }}
        variant="secondary"
        size="xs"
        title="Attachments"
      >
        {attachments !== 0 && <div className="count">{attachments}</div>}
        <i className="fas fa-paperclip fa-fw" />
      </Button>
    );
  }

  renderPrintButton() {
    const { itemName, itemId } = this.props;
    if (itemName !== 'SMM1') {
      return null;
    }

    return (
      <Button
        onClick={() => {
          modal.open('PrintHardCard', {
            title: `Print Hard Card ${itemId}`,
            style: 'center',
            size: 'md',
            hidePrint: true,
            hideFooter: true,
            message: <PrintHardCard roId={itemId} />,
          });
        }}
        variant="info"
        size="xs"
        title="Print Hard Card"
      >
        <i className="fas fa-print fa-fw" />
      </Button>
    );
  }

  renderVoidButton() {
    const { itemName, itemId } = this.props;
    if (itemName !== 'SMM1') {
      return null;
    }

    return (
      <Button
        onClick={() => {
          modal.open('VoidRO', {
            title: `Void RO ${itemId}`,
            style: 'center',
            size: 'md',
            hidePrint: true,
            hideFooter: true,
            message: <VoidRo roId={itemId} />,
          });
        }}
        variant="danger"
        size="xs"
        title="Void"
      >
        <i className="fas fa-minus-circle fa-fw" />
      </Button>
    );
  }

  renderAuditButton() {
    const { itemName, itemId } = this.props;
    if (itemName !== 'EQS1') {
      return null;
    }

    return (
      <Button
        onClick={() => {
          modal.open('QuoteHistory', {
            title: `Quote History ${itemId}`,
            size: 'lg',
            style: 'center',
            hidePrint: true,
            message: <QuoteHistory quoteId={itemId} />,
          });
        }}
        variant="info"
        size="xs"
        title="History"
      >
        <i className="fab fa-buffer fa-fw" />
      </Button>
    );
  }

  /**
   * Refund only available on UPY4.
   * UPY3 doesn't load the necessary data be default to determine if a transaction is refundable.
   */
  renderPaymentRefundButton() {
    const { itemName, rowData } = this.props;

    if (itemName !== 'UPY4') {
      return;
    }

    const paymentSession = new PaymentSession(rowData);

    const canRefund =
      paymentSession.status !== 'open' && paymentSession.department !== 'parts' && paymentSession.canRefund();

    if (!canRefund) {
      return null;
    }

    const handleSuccess = response => {
      // pop a toaster?
    };

    return (
      <Button
        onClick={() => {
          modal.open({
            title: 'Refund',
            size: 'md',
            hidePrint: true,
            hideFooter: true,
            staticBackdrop: true,
            headerClass: 'primary',
            message: (
              <PaymentSessionRefund
                sessionId={paymentSession.id}
                customerNum={paymentSession.customerNum}
                onSuccess={handleSuccess}
              />
            ),
          });
        }}
        variant="warning"
        size="xs"
        title="Refund"
      >
        <i className="fa-solid fa-money-bill-transfer" />
      </Button>
    );
  }

  renderPaymentResumeButton() {
    const { itemName, rowData } = this.props;

    if (!['UPY3', 'UPY4', 'UPY5'].includes(itemName)) {
      return;
    }

    const resumeProps = {
      userInitials: rowData.userInitials || rowData.Initials,
    };

    const resumeButton = {
      variant: 'success',
      title: 'Resume Payment',
      icon: 'fas fa-play-circle fa-fw',
    };

    const infoButton = {
      variant: 'info',
      title: 'Check Payment',
      icon: 'fas fa-info-circle fa-fw',
    };

    let btnType = resumeButton;
    let invoiceNum;
    let originalInvoiceNum;
    let isCredit;
    let customerNum;
    let amount;
    let status;
    let paymentSession;

    // UPY3/4 should have a payment session
    if (itemName === 'UPY3') {
      paymentSession = rowData.PaymentSession;
    } else if (itemName === 'UPY4') {
      paymentSession = rowData;
    }

    if (['UPY3', 'UPY4'].includes(itemName)) {
      resumeProps.sessionId = paymentSession.id;
      resumeProps.department = paymentSession.department;

      if (paymentSession.status !== 'open') {
        btnType = infoButton;
      }

      customerNum = paymentSession.customerNum;
      invoiceNum = _.get(paymentSession, 'invoices[0].invoiceNum');
      originalInvoiceNum = _.get(paymentSession, 'invoices[0].originalInvoiceNum');
      amount = paymentSession.amount;
      isCredit = paymentSession.amount < 0;
      status = paymentSession.status;
    } else if (itemName === 'UPY5') {
      invoiceNum = rowData.itemid;
      resumeProps.invoiceNum = invoiceNum;
      customerNum = rowData['Customer #'];
      resumeProps.customerNum = customerNum;
      resumeProps.amount = parseFloat(rowData['Amount'].replace(/[^0-9.]/g, ''));
      resumeProps.department = 'parts';
    }

    if (isCredit) {
      resumeProps.invoiceNum = invoiceNum;
      resumeProps.originalInvoiceNum = originalInvoiceNum;
      resumeProps.amount = amount;
      resumeProps.customerNum = customerNum;
      resumeProps.selectCashInvoicePrinter = true;
    }

    const handleCancel = async response => {
      try {
        if (resumeProps.department === 'parts') {
          await cancelInvoice({
            customerNum,
            [isCredit ? 'creditInvoiceNum' : 'invoiceNum']: invoiceNum,
            ppc: Auth.getUser().ppc,
          });
        }

        // We have a successful QM cancelation here, mark it so in the payment session
        ApiService.put(`/payment/session/${response.sessionId}/cancel`).catch(err => {
          console.error(err);
          toastr.error('Payment session failed to cancel.');
        });
      } catch (err) {
        // cancelInvoice pops QM errors itself (possibly > 1) and throws
        console.error(err);
      }
    };

    const handleSuccess = async response => {
      let invoiceProcessingModalOpen = false;
      try {
        const printerID = _.get(response, 'printer.id', '');
        const printerName = _.get(response, 'printer.name', '');

        // Physical printer actions are almost always instant, so we'll only show the processing
        // modal in instances of screen prints, which can take several seconds to complete.
        if (printerName === 'Screen') {
          this.showInvoiceProcessingModal();
          invoiceProcessingModalOpen = true;
        }

        const res = await validateInvoice({
          customerNum,
          invoiceNum,
          ppc: resumeProps.userInitials, // For sales credit purposes, prob best to leave as original PPC
          printerID,
          printerName,
          transactions: response.transactions,
        });

        // We have a successful QM validation here, mark it so in the payment session
        ApiService.put(`/payment/session/${response.sessionId}/complete`).catch(err => {
          console.error(err);
          toastr.error('Payment session failed to complete.');
        });

        // Screen print support
        if (printerName === 'Screen') {
          modal.close(); // close invoiceProcessingModal
          invoiceProcessingModalOpen = false;
          this.showScreenPrintModal(res.screenPrintDocs);
        }
      } catch (err) {
        // validateInvoice pops QM errors itself (possibly > 1) and throws
        console.error(err);

        if (invoiceProcessingModalOpen) {
          modal.close(); // close invoiceProcessingModal
        }
      }
    };

    const ResumeComponent = isCredit && status === 'open' ? PaymentCreditForm : PaymentSaleFormResume;

    return (
      <Button
        onClick={() => {
          modal.open({
            title: btnType.title,
            size: 'md',
            hidePrint: true,
            hideFooter: true,
            staticBackdrop: true,
            headerClass: 'primary',
            message: <ResumeComponent {...resumeProps} onCancel={handleCancel} onSuccess={handleSuccess} />,
          });
        }}
        variant={btnType.variant}
        size="xs"
        title={btnType.title}
      >
        <i className={btnType.icon} />
      </Button>
    );
  }

  renderQuoteDocument() {
    const { itemName, itemId } = this.props;
    if (itemName !== 'EQS1') {
      return null;
    }

    return (
      <Button
        onClick={() => {
          modal.open('QuoteDocuments', {
            title: `Quote Documents ${itemId}`,
            size: 'md',
            hidePrint: true,
            style: 'center',
            message: <QuoteDocuments quoteId={itemId} />,
          });
        }}
        variant="secondary"
        size="xs"
        title="Documents"
      >
        <i className="fas fa-print fa-fw" />
      </Button>
    );
  }

  renderNotesButton() {
    const { canNotes, rowData } = this.props;

    if (!canNotes) {
      return null;
    }

    const noteCount = this.state.notes || rowData.noteCount;

    return (
      <Button
        onClick={() => {
          this.showNotes(rowData);
        }}
        variant="secondary"
        size="xs"
        title="Notes"
      >
        {noteCount !== 0 && <div className="count">{noteCount}</div>}
        <i className="fas fa-comment-alt fa-fw" />
      </Button>
    );
  }

  renderUPY6Buttons() {
    const { itemId, itemName, rowData } = this.props;
    if (itemName !== 'UPY6') {
      return null;
    }

    const amount = parseFloat(rowData['Amount'].replace(/[^0-9.]/g, ''));
    const creditInvoiceNum = rowData['Credit Invoice #'];
    const customerNum = rowData['Customer #'];
    const originalInvoiceNum = rowData['Sale Invoice #'];

    const handleCreditInvoiceDelete = () => {
      modal.confirm({
        title: 'Delete',
        message: `Delete pending credit invoice ${creditInvoiceNum} ?`,
        callback: async () => {
          try {
            await cancelInvoice({
              customerNum,
              creditInvoiceNum,
              ppc: Auth.getUser().ppc,
            });

            // get all open payment sessions matching the credit invoice
            const response = await ApiService.get('/payment/session', {
              params: { invoiceNum: creditInvoiceNum, status: 'open' },
            });

            if (response.data && response.data.length) {
              // should only be one but you never know
              for (const session of response.data) {
                ApiService.put(`/payment/session/${session.id}/cancel`).catch(err => {
                  console.error(err);
                  toastr.error('Payment session failed to cancel.');
                });
              }
            }
          } catch (err) {
            // cancelInvoice pops QM errors itself (possibly > 1) and throws
            console.error(err);
          }
        },
      });
    };

    const handleCreditResume = () => {
      const handleSuccess = async response => {
        let invoiceProcessingModalOpen = false;
        try {
          const printerID = _.get(response, 'printer.id', '');
          const printerName = _.get(response, 'printer.name', '');

          // Physical printer actions are almost always instant, so we'll only show the processing
          // modal in instances of screen prints, which can take several seconds to complete.
          if (printerName === 'Screen') {
            this.showInvoiceProcessingModal();
            invoiceProcessingModalOpen = true;
          }

          const res = await validateInvoice({
            customerNum,
            invoiceNum: creditInvoiceNum,
            ppc: Auth.getUser().ppc,
            printerID,
            printerName,
            transactions: response.transactions,
          });

          // We have a successful QM validation here, mark it so in the payment session
          ApiService.put(`/payment/session/${response.sessionId}/complete`).catch(err => {
            console.error(err);
            toastr.error('Payment session failed to complete.');
          });

          // Screen print support
          if (printerName === 'Screen') {
            modal.close(); // close invoiceProcessingModal
            invoiceProcessingModalOpen = false;
            this.showScreenPrintModal(res.screenPrintDocs);
          }
        } catch (err) {
          // validateInvoice pops QM errors itself (possibly > 1) and throws
          console.error(err);

          if (invoiceProcessingModalOpen) {
            modal.close(); // close invoiceProcessingModal
          }
        }
      };

      // PaymentCreditForm will check for existing open payment sessions
      modal.open({
        title: 'Resume Credit',
        size: 'md',
        hidePrint: true,
        hideFooter: true,
        staticBackdrop: true,
        headerClass: 'primary',
        message: (
          <PaymentCreditForm
            amount={amount}
            invoiceNum={creditInvoiceNum}
            originalInvoiceNum={originalInvoiceNum}
            customerNum={customerNum}
            department="parts"
            onSuccess={handleSuccess}
            selectCashInvoicePrinter={true}
            userInitials={Auth.getUser().ppc}
          />
        ),
      });
    };

    // This should be a DSI only function to clean up orphaned credit invoices.
    // If clerks follow proper procedures, the should not exist.
    const deleteButton = (
      <Button
        onClick={handleCreditInvoiceDelete}
        variant="danger"
        size="xs"
        title="Delete Pending Credit Invoice"
        className="list-delete-button"
      >
        <i className="fas fa-times fa-fw" />
      </Button>
    );

    const creditResumeButton = (
      <Button onClick={handleCreditResume} variant="success" size="xs" title="Resume Credit">
        <i className="fas fa-play-circle fa-fw" />
      </Button>
    );

    return (
      <>
        {creditResumeButton}
        {Auth.isDsiSupport() ? deleteButton : null}
      </>
    );
  }

  showInvoiceProcessingModal() {
    modal.open({
      title: 'Processing',
      size: 'sm',
      closeButton: false,
      hidePrint: true,
      hideFooter: true,
      staticBackdrop: true,
      headerClass: 'default',
      message: (
        <div style={{ textAlign: 'center' }}>
          <br />
          <ScaleLoader size={80} color="gray" />
          <br />
          <br />
          Invoice transaction in progress.
          <br />
          Please wait.
        </div>
      ),
    });
  }

  showScreenPrintModal(screenPrintDocs) {
    if (screenPrintDocs.length > 0) {
      modal.open({
        title: 'Print Documents',
        size: 'lg',
        hidePrint: true,
        hideFooter: true,
        staticBackdrop: true,
        headerClass: 'default',
        message: (
          <Tab.Container id="left-tabs" defaultActiveKey="evt0">
            <Row className="clearfix">
              <Col sm={3}>
                <Nav variant="pills" className="flex-column">
                  {screenPrintDocs.map((doc, index) => (
                    <Nav.Item key={index}>
                      <Nav.Link eventKey={`evt${index}`}>{doc.title}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col sm={9}>
                <Tab.Content>
                  {screenPrintDocs.map((doc, index) => (
                    <Tab.Pane key={index} eventKey={`evt${index}`}>
                      <PdfObject url={doc.url} width="100%" height="800" />
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        ),
      });
    }
  }

  render() {
    return (
      <ButtonGroup className="list-row-toolbar" id={`list-toolbar-${this.props.itemId}`}>
        {this.renderReadButton()}
        {this.renderEditButton()}
        {this.renderPermissionsButton()}
        {this.renderSwitchUserButton()}
        {this.renderAddButton()}
        {this.renderDeleteButton()}
        {this.renderUploadButton()}
        {this.renderPrintButton()}
        {this.renderVoidButton()}
        {this.renderAuditButton()}
        {this.renderQuoteDocument()}
        {this.renderPaymentResumeButton()}
        {this.renderUPY6Buttons()}
        {this.renderNotesButton()}
        {this.renderPaymentRefundButton()}
      </ButtonGroup>
    );
  }
}

ListRowToolbar.defaultProps = {
  canRead: false,
};

ListRowToolbar.propTypes = {
  attachments: PropTypes.number,
  canCopy: PropTypes.bool,
  canDelete: PropTypes.bool,
  canEdit: PropTypes.bool,
  canRead: PropTypes.bool,
  canUpload: PropTypes.bool,
  canViewAttachments: PropTypes.bool,
  handleRemoveItem: PropTypes.func,
  itemId: PropTypes.string,
  itemName: PropTypes.string,
  namespace: PropTypes.string,
  rowData: PropTypes.object,
};

export default ListRowToolbar;
